import { useEffect, useState } from 'react';
import { Alert, Spin } from 'antd';

import MyExpenseListComponent from '../../components/expenses/MyExpenseListComponent';
import {
  excludeExpense,
  syncCardApprovalListByUser,
  updateExpenseWithAssetData,
} from '../../api/constlink';
import { Expense, getMyExpenseListAsync } from '../../modules/expenses';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import MyExpenseSubmitModal from '../../components/expenses/MyExpenseSubmitModal';

interface MyExpenseListContainerProps {
  enterpriseId: string;
}

function MyExpenseListContainer({ enterpriseId }: MyExpenseListContainerProps) {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector(
    (state: RootState) => state.expenses.expenses,
  );
  const [syncCardApprovalLoading, setSyncCardApprovalLoading] = useState(false);
  const [expense, setExpense] = useState<Expense>();

  useEffect(() => {
    dispatch(
      getMyExpenseListAsync.request({
        enterpriseId,
      }),
    );
  }, [dispatch, enterpriseId]);

  const _syncCardApprovalList = async () => {
    setSyncCardApprovalLoading(true);
    await syncCardApprovalListByUser({ enterpriseId });
    setSyncCardApprovalLoading(false);
    dispatch(
      getMyExpenseListAsync.request({
        enterpriseId,
      }),
    );
  };

  const onRegister = (value: any) => {
    if (data === null) return;

    setExpense(data.find((expense) => expense.id === value));
  };

  const onExclude = async (expenseId: number) => {
    await excludeExpense({
      enterpriseId,
      expenseId: expenseId + '',
    });
    dispatch(
      getMyExpenseListAsync.request({
        enterpriseId,
      }),
    );
  };

  const onCreate = async (value: any) => {
    if (expense === undefined) return;

    await updateExpenseWithAssetData({
      enterpriseId,
      expenseId: expense.id + '',
      expense: { ...value, projectId: value.project.id + '' },
    });
    setExpense(undefined);
    dispatch(
      getMyExpenseListAsync.request({
        enterpriseId,
      }),
    );
  };

  const onCancel = () => {
    setExpense(undefined);
  };

  return (
    <>
      {loading && <Spin />}
      {error && (
        <Alert
          message={`${error.response?.data.message}`}
          type="error"
          showIcon
          closable
        />
      )}
      {data && (
        <MyExpenseListComponent
          data={data}
          syncCardApprovalLoading={syncCardApprovalLoading}
          onRegister={onRegister}
          onExclude={onExclude}
          syncCardApprovalList={_syncCardApprovalList}
        />
      )}
      {expense && (
        <MyExpenseSubmitModal
          expense={expense}
          enterpriseId={enterpriseId}
          onCreate={onCreate}
          onCancel={onCancel}
        />
      )}
    </>
  );
}

export default MyExpenseListContainer;
